import { mdiDesktopClassic } from '@mdi/js'

export default {
  title: 'E-Learning Teacher',
  icon: mdiDesktopClassic,
  to: 'elearning-teacher',
  resource: 'ElearningTeacher',
  action: 'read',
}
